import { PersonalInfo } from '@/network/api'

export default {
	
	AddInformation(context,val){
		 context.commit('AddInformation',val)
	},
	
	GetroundNum(context,val){
		context.commit('GetroundNum',val)
	},
	
	GetVsKaiShi(context,val){
		context.commit('GetVsKaiShi',val)
	},
	
	GetVsJieShu(context,val){
		context.commit('GetVsJieShu',val)
	},
	
	GetKaiShiVsData(context,val){
		context.commit('GetKaiShiVsData',val)
	},
	
	GetJieShuVsData(context,val){
		context.commit('GetJieShuVsData',val)
	},
	
	GetRegisterShow(context,val){
		context.commit('GetRegisterShow',val)
	},
	
	GetSignInShow(context,val){
		context.commit('GetSignInShow',val)
	},
	
  Refresh(context) {
    PersonalInfo().then(res => {
      context.commit('User', res.data.message)
    })
  }
}